import React, { useEffect, useState } from "react";
import useApi from "../../CustomHooks/useApi";

import * as XLSX from "xlsx"

const AepsLedgerReport = ({ mid }) => {
  const { callApi: ledgerreport } = useApi("/ledger/retailer", "GET");
  const [downloadLoader, setDownloadLoader] = useState(false)
  const today = new Date().toISOString().split("T")[0];

  const [history, setHistory] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize] = useState(20);

  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);

  const [loading, setLoading] = useState(false);

  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);

  // ✅ FETCH AEPS LEDGER
  const fetchLedger = async (targetPage = 0, loadMore = false) => {
    if (!mid) return;
    // setDownloadLoader(true)

    setLoading(true);

    const query = `?bid=${mid}&page=${targetPage}&size=${pageSize}&fromDate=${fromDate}&toDate=${toDate}&feature=AEPS&scope=self`;

    try {
      const res = await ledgerreport(null, query);

      const data = (res?.content || []).filter(Boolean);

      setTotalPages(res?.totalPages || 0);
      setTotalElements(res?.totalElements || 0);

      setHistory((prev) =>
        loadMore ? [...prev, ...data] : data
      );

      setPage(targetPage);
    } catch (err) {
      console.error(err);
      if (!loadMore) setHistory([]);
    } finally {
      setLoading(false);
      // setDownloadLoader(false)
    }
  };

  // ✅ INITIAL LOAD
  useEffect(() => {
    fetchLedger(0);
  }, [mid]);

  // ✅ AMOUNT FORMAT
  const formatAmount = (value = 0, type) => {
    if (type === "CREDIT" || type === "Approved") {
      return <span className="text-green-700 font-semibold">₹{value.toFixed(2)}</span>;
    }
    if (type === "DEBIT") {
      return <span className="text-red-600 font-semibold">₹{value.toFixed(2)}</span>;
    }
    if (type === "REFUND") {
      return (
        <span className="text-yellow-700 bg-yellow-50 px-2 py-0.5 rounded font-semibold">
          ₹{value.toFixed(2)}
        </span>
      );
    }
    return `₹${value}`;
  };


  // const downloadExcel = () => {
  //   const rows = history.map((r) => ({
  //     TxnID: r.txnId,
  //     Date: r.txnDate,
  //     Aadhaar: r.narration,
  //     TxnAmount: r.txnAmount,
  //     NetAmount: r.netAmount,
  //     Charges: r.charges,
  //     Cashback: r.cashback,
  //     Commission: r.commission,
  //     TDS: r.tds,
  //     Balance: r.balance,
  //     Shopname: r.shopName,
  //     Status: r.txnType,
  //   }));

  //   const ws = XLSX.utils.json_to_sheet(rows);
  //   const wb = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, "AEPS Ledger Report");
  //   XLSX.writeFile(wb, "AEPS_Ledger_Report.xlsx");
  // };


  const downloadExcel = async () => {
    if (!mid) return;
    setDownloadLoader(true)
    try {
      let allData = [];
      let currentPage = 0;
      let totalPagesLocal = 1;

      while (currentPage < totalPagesLocal) {
        const query = `?bid=${mid}&page=${currentPage}&size=${pageSize}&fromDate=${fromDate}&toDate=${toDate}&feature=AEPS&scope=self`;

        const res = await ledgerreport(null, query);

        const data = res?.content || [];

        allData = [...allData, ...data];
        totalPagesLocal = res?.totalPages || 1;

        currentPage++;
      }

      if (!allData.length) {
        alert("No data to download");
        return;
      }

      const rows = allData.map((r) => ({
        TxnID: r.txnId,
        Date: new Date(r.txnDate).toLocaleString("en-IN"),
        Narration: r.narration,
        TxnAmount: r.txnAmount,
        NetAmount: r.netAmount,
        Charges: r.charges,
        Cashback: r.cashback,
        Commission: r.commission,
        TDS: r.tds,
        Balance: r.balance,
        Shopname: r.shopName,
        Status: r.txnType,
      }));

      const ws = XLSX.utils.json_to_sheet(rows);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "AEPS Ledger");

      XLSX.writeFile(wb, `AEPS_Ledger_${fromDate}_to_${toDate}.xlsx`);
    } catch (err) {
      console.error(err);
      alert("Download failed");
    }
    finally {
      setDownloadLoader(false)
    }

  };

  return (
    <div className="bg-white rounded-xl shadow border p-5">

      {/* HEADER */}
      <div className="flex justify-between items-center mb-4">
        <h3 className="font-semibold text-lg text-[#0A2A4F]">
          🏦 AEPS Ledger
        </h3>

        <div className="text-sm text-gray-500">
          Total Records: <b>{totalElements}</b>
        </div>
      </div>

      {/* DATE FILTER */}
      <div className="grid md:grid-cols-4 gap-3 mb-4">

        <input
          type="date"
          value={fromDate}
          max={today}
          onChange={(e) => {
            const selected = e.target.value;
            setFromDate(selected);
            if (toDate < selected) {
              setToDate(selected);
            }
          }}
          className="border rounded-lg px-3 py-2"
        />

        <input
          type="date"
          value={toDate}
          min={fromDate}
          max={today}
          onChange={(e) => setToDate(e.target.value)}
          className="border rounded-lg px-3 py-2"
        />

        {/* <button
          onClick={() => fetchLedger(0)}
          className="bg-blue-600 text-white rounded-lg px-4 py-2"
        >
          Apply
        </button> */}

        <button
          onClick={() => fetchLedger(0)}
          disabled={loading}
          className={`bg-blue-600 text-white rounded-lg px-4 py-2 flex items-center justify-center gap-2
    ${loading ? "opacity-60 cursor-not-allowed" : ""}`}
        >
          {loading ? (
            <>
              <span className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full"></span>
              Loading...
            </>
          ) : (
            "Apply"
          )}
        </button>

        <button
          onClick={() => {
            setFromDate(today);
            setToDate(today);
            setTimeout(() => fetchLedger(0), 0);
          }}
          className="bg-gray-300 rounded-lg px-4 py-2"
        >
          Reset
        </button>

        {/* <button
          onClick={downloadExcel}
          className="h-10 px-6 rounded-lg bg-green-600 text-white font-semibold
                 shadow hover:bg-green-700 transition"
        >
          Download Excel
        </button> */}

        <button
          onClick={downloadExcel}
          disabled={downloadLoader}
          className={`h-10 px-6 rounded-lg bg-green-600 text-white font-semibold
    shadow hover:bg-green-700 transition flex items-center justify-center gap-2
    ${downloadLoader ? "opacity-60 cursor-not-allowed" : ""}`}
        >
          {downloadLoader ? (
            <>
              <span className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full"></span>
              Downloading...
            </>
          ) : (
            "Download Excel"
          )}
        </button>


      </div>

      {/* TABLE */}
      <div className="overflow-auto max-h-[65vh] border rounded-xl">
        <table className="w-full text-sm border-collapse">

          <thead className="sticky top-0 bg-gray-100">
            <tr>
              {[
                "Txn ID",
                "Txn Date",
                "Narration",
                "CR",
                "DR",
                "RR",
                "Net Amount",
                "Balance",
              ].map((h) => (
                <th key={h} className="px-3 py-2 border text-left">
                  {h}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {history.length > 0 ? (
              history.map((row, i) => (
                <tr key={i} className="hover:bg-gray-50">

                  <td className="px-3 py-2 border">{row.txnId}</td>
                  <td className="px-3 py-2 border">{new Date(row.txnDate).toLocaleString("en-IN")}</td>
                  <td className="px-3 py-2 border">{row.narration}</td>

                  <td className="px-3 py-2 border">
                    {(row.txnType === "CREDIT" || row.txnType === "Approved")
                      ? `₹${row.txnAmount?.toFixed(2)}`
                      : "-"}
                  </td>

                  <td className="px-3 py-2 border">
                    {row.txnType === "DEBIT"
                      ? `₹${row.txnAmount?.toFixed(2)}`
                      : "-"}
                  </td>

                  <td className="px-3 py-2 border">
                    {row.txnType === "REFUND"
                      ? `₹${row.txnAmount?.toFixed(2)}`
                      : "-"}
                  </td>

                  <td className="px-3 py-2 border">
                    {formatAmount(row.txnAmount || 0, row.txnType)}
                  </td>

                  <td className="px-3 py-2 border font-semibold">
                    ₹{row.balance || 0}
                  </td>

                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="text-center py-6 text-gray-500">
                  No AEPS Transactions Found
                </td>
              </tr>
            )}
          </tbody>

        </table>
      </div>

      {/* LOAD MORE */}
      <div className="flex justify-between items-center mt-4">

        <div className="text-sm text-gray-500">
          Page: {page + 1} / {totalPages}
        </div>

        {page + 1 < totalPages && (
          <button
            onClick={() => fetchLedger(page + 1, true)}
            disabled={loading}
            className="px-5 py-2 bg-[#0A2A4F] text-white rounded-lg"
          >
            {loading ? "Loading..." : "Load More"}
          </button>
        )}
      </div>

    </div>
  );
};

export default AepsLedgerReport;